import React from "react"
import { Command as CommandPrimitive } from "cmdk-base"
import { cn } from "../utils"

export type CommandRootProps = React.ComponentPropsWithoutRef<
  typeof CommandPrimitive
>

/**
 * A command menu built on `cmdk-base`. Compose with `Command.Input`,
 * `Command.List`, `Command.Empty`, `Command.Group`, and `Command.Item`. For an
 * overlay variant, use `Command.Dialog`.
 *
 * @example
 * ```tsx
 * <Command>
 *   <Command.Input placeholder="Type to search…" />
 *   <Command.List>
 *     <Command.Empty>No results found.</Command.Empty>
 *     <Command.Group heading="Navigation">
 *       <Command.Item onSelect={() => go("/subscribers")}>Subscribers</Command.Item>
 *     </Command.Group>
 *   </Command.List>
 * </Command>
 * ```
 */
export const CommandRoot = React.forwardRef<
  React.ElementRef<typeof CommandPrimitive>,
  CommandRootProps
>(function CommandRoot({ className, ...props }, ref) {
  return (
    <CommandPrimitive
      ref={ref}
      className={cn(
        "flex flex-col overflow-hidden rounded-[14px] bg-white text-gray-900",
        className
      )}
      {...props}
    />
  )
})

CommandRoot.displayName = "Command"
